import React from 'react';
import {Link, useLocation} from "react-router-dom";
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {useAuth} from "../../../modules/auth";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import {KTIcon} from "../../../../_metronic/helpers";
import phoneFormatter from "../../../utils/phoneFormatter";

const tabLinks = [
  {
    title: 'Umumiy',
    link: '/profile/overview'
  },
  {
    title: 'Xavfsizlik',
    link: '/profile/security'
  }
]

export const ProfilePage = ({children}) => {
  const {pathname} = useLocation()
  const {currentUser} = useAuth()

  const pageDetails = {
    title: "Akkount",
    desc: "Akkount ma'lumotlari"
  };

  return (
      <div>
        <div>
          <div>
            <PageHeader pageDetails={pageDetails}/>
            <div className="card mb-5 mb-xl-10">
              <div className="card-body pt-9 pb-0">
                <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                  <div className="me-7 mb-4">
                    <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                      <img
                           className={"object-fit-cover"}
                        src={currentUser?.avatar || PLACEHOLDER_IMAGE_URL} alt={
                        currentUser?.first_name + ' ' + currentUser?.last_name
                    }/>
                    </div>
                  </div>
                  <div className="flex-grow-1 align-items-center">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
                      <div className="d-flex flex-column">
                        <div className="d-flex align-items-center mb-2">
                          <span className="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">{currentUser?.first_name} {currentUser?.last_name}</span>
                          <span>
                            <KTIcon iconName={"verify"} className={"fs-1 text-primary"}/>
                           </span>
                          </div>
                        <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                          <span className="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2">
                            <KTIcon iconName={"profile-circle"} className={"fs-4 me-1"}/>{currentUser?.role.toUpperCase()}</span>
                          <span className="d-flex align-items-center text-gray-500 text-hover-primary mb-2">
                            <KTIcon iconName={"phone"} className={"fs-4 me-1"}/>{phoneFormatter(`998${currentUser?.phone!}`)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex overflow-auto h-55px">
                  <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
                    {
                      tabLinks.map((tab, index) => (
                          <li key={index} className="nav-item">
                            <Link className={`nav-link text-active-primary me-6 ${
                                pathname === tab.link ? 'active' : ''
                            }`} to={tab.link}>
                              {tab.title}
                            </Link>
                          </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-5">{children}</div>
          </div>
        </div>
      </div>
  );
};
